import React from "react";
import axios from "axios";

function ResetPasswordForm({ token, onSwitchToSignIn }) {
    const [state, setState] = React.useState({
        password: "",
        password_confirmation: ""
    });
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleChange = (evt) => {
        setError(null);
        setState({ ...state, [evt.target.name]: evt.target.value });
    };

    const handleOnSubmit = async (evt) => {
        evt.preventDefault();
        setError(null);

        if (state.password !== state.password_confirmation) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }

        setLoading(true);

        try {
            const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            await axios.put(
                '/api/v1/auth/reset_password',
                {
                    user: {
                        reset_password_token: token,
                        password: state.password,
                        password_confirmation: state.password_confirmation
                    }
                },
                {
                    headers: {
                        'X-CSRF-Token': csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            setSuccess(true);
        } catch (err) {
            const errors = err.response?.data?.errors;
            const msg = (errors && errors.length > 0)
                ? errors.join(', ')
                : err.response?.data?.message || "Une erreur est survenue. Veuillez réessayer.";
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="form-container sign-in-container">
                <div className="auth-form">
                    <h1 className="auth-title">Mot de passe modifié !</h1>
                    <div style={{
                        color: '#38A169',
                        background: 'rgba(56,161,105,0.08)',
                        border: '1px solid rgba(56,161,105,0.30)',
                        borderRadius: '8px',
                        padding: '14px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        textAlign: 'center',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        ✅ Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter.
                    </div>
                    <button
                        className="auth-button"
                        onClick={() => onSwitchToSignIn && onSwitchToSignIn()}
                    >
                        Se connecter
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="form-container sign-in-container">
            <form className="auth-form" onSubmit={handleOnSubmit}>
                <h1 className="auth-title">Nouveau mot de passe</h1>
                <p className="auth-paragraph" style={{ textAlign: 'center', marginBottom: '20px', fontSize: '14px' }}>
                    Choisissez un nouveau mot de passe sécurisé.
                </p>
                {error && (
                    <div style={{
                        color: '#7c2837',
                        background: 'rgba(124,40,55,0.08)',
                        border: '1px solid rgba(124,40,55,0.30)',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        marginBottom: '12px',
                        fontSize: '13px',
                        fontWeight: '600',
                        textAlign: 'center',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        ❌ {error}
                    </div>
                )}
                <input
                    type="password"
                    name="password"
                    placeholder="Nouveau mot de passe"
                    value={state.password}
                    onChange={handleChange}
                    className="auth-input"
                    required
                />
                <input
                    type="password"
                    name="password_confirmation"
                    placeholder="Confirmer le mot de passe"
                    value={state.password_confirmation}
                    onChange={handleChange}
                    className="auth-input"
                    required
                />
                <button type="submit" className="auth-button" disabled={loading}>
                    {loading ? 'Modification en cours…' : 'Modifier mon mot de passe'}
                </button>
                <a
                    className="auth-link"
                    href="#"
                    onClick={(e) => { e.preventDefault(); onSwitchToSignIn && onSwitchToSignIn(); }}
                >
                    ← Retour à la connexion
                </a>
            </form>
        </div>
    );
}

export default ResetPasswordForm;
